import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// core components
import Navbar from "components/Navbars/Navbar.js";
import SubHeader from "components/Headers/SubHeaderBanner";
import DarkFooter from "components/Footers/DarkFooter.js";
import PanelCountdown from "components/PanelCountdown";


function Visa() {
    React.useEffect(() => {
        document.body.classList.add("index-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        return function cleanup() {
            document.body.classList.remove("index-page");
            document.body.classList.remove("sidebar-collapse");
        };
    });

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        event.preventDefault()
    };


    return (
        <>
            <Navbar />
            <SubHeader title="VISA" image={require("assets/img/Macau-2026/visa_banner_macau.jpeg")} />
            <div className="wrapper position-relative">
                <div className="container main my-5">
                    <section className="section gb nopadtop">
                        <div className="container">
                            <div className="boxed boxedp4">
                                    <div className="section-title">
                                        <h2 className="text-center font-weight-bold">VISA REQUIREMENTS</h2>
                                    </div>
                                <div className="bg-white shadow px-2 pt-5 pb-3 my-3">
                                    <div className="col-md-12 mb-5">
                                    <p className=''> All visitors must hold a passport or a valid travel document for travel to Macao.</p>
                                         <p className="text-justify">
                                         A Macau visa can be obtained through the Embassies / Consulates of the PRC and should be used within its validity. 
                                         Visitors may also apply for an entry permit or visa upon arrival at the immigration checkpoint. 
                                         However, visitors from certain countries are required to obtain a visa in advance before their trip to Macao. 
                                         For more information, please visit the website: <a target='_blank' href='https://www.fsm.gov.mo/psp/eng/psp_top5_3m.html'>www.fsm.gov.mo/psp/eng/psp_top5_3m.html</a>
                                        </p>
                                        <p>Please visit the website of the Macao Immigration Services of Public Security Police Force: <br/> 
                                        <a target='_blank' href='https://www.gov.mo/en/services/ps-1474/ps-1474b/'>https://www.gov.mo/en/services/ps-1474/ps-1474b/</a>
                                
                                            </p>
                                       
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
                <PanelCountdown date="02/18/2025" />
                {/* <DarkFooter /> */}
            </div>
        </>
    );
}

export default Visa;
